import { type HTMLAttributes } from 'react'

import { PageContainerWrapper } from '@/components/shared/page-container/styled'
import { type ResponsiveProp } from '@/ui/typings/helpers'

type PageContainerProps = HTMLAttributes<HTMLDivElement> & {
  //TODO: Import type from component library
  as?: string | React.ComponentType<unknown>
  /**
   * Bottom container margin
   */
  bottom?: ResponsiveProp<string>
  /**
   * Top container margin
   */
  top?: ResponsiveProp<string>
  /**
   * Condenses the max-width for desktop views and adds more gutter on tablet
   */
  isCondensed?: boolean
  /**
   * Adjusts the max-width for desktop views to the full-max  and adds more gutter on tablet
   */
  isFullMax?: boolean

  removeMobilePadding?: boolean
}

/**
 * Container to wrap all pages of application.
 * It automatically centralizes components in the max-width.
 */

export const PageContainer = ({
  bottom = '3rem',
  isCondensed = false,
  isFullMax = false,
  removeMobilePadding = false,
  top = '3rem',

  ...rest
}: PageContainerProps) => {
  return (
    <PageContainerWrapper
      $isCondensed={isCondensed}
      $isFullMax={isFullMax}
      $removeMobilePadding={removeMobilePadding}
      $bottom={bottom}
      $top={top}
      {...rest}
    />
  )
}
